import { render, staticRenderFns } from "./declaracao_nota.vue?vue&type=template&id=1726a8c3&"
import script from "./declaracao_nota.vue?vue&type=script&lang=js&"
export * from "./declaracao_nota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports